module.exports = __webpack_public_path__ + "static/media/A2_09.3bc7e103.png";